import { Link, Stack, Text } from "@certn/cascadia";
import { NavLogo } from "@certn/cascadia-react/components/navigation/navigation-top/NavLogo";
import { useCallback, useEffect, useMemo } from "react";
import { Trans } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { parseKonfirCallbackState } from "./helpers";

export function KonfirCallback() {
  const [searchParams] = useSearchParams();
  const { caseId } = useMemo(
    () => parseKonfirCallbackState(searchParams.get("state")),
    [searchParams]
  );

  const applyUrl = caseId ? `/apply/${caseId}/employment-verification` : "/";

  const returnToCertn = useCallback(() => {
    if (window.opener) {
      window.opener.focus();
      window.close();
    } else {
      window.location.href = applyUrl;
    }
  }, [applyUrl]);

  // Close this window as soon as Konfir hands off, so the applicant cannot
  // navigate back into an already-submitted Konfir session (which Konfir
  // rejects with a 409 and surfaces as a confusing "error connecting to HMRC").
  // The visible link below is the fallback for browsers that block the
  // programmatic close.
  useEffect(() => {
    returnToCertn();
  }, [returnToCertn]);

  return (
    <Stack align="center" gap="space-46">
      <div style={{ width: 120, paddingTop: 20 }}>
        <NavLogo />
      </div>
      <Stack gap="space-4" align="center">
        <Text style="card/title-large" align="center">
          <Trans>Returning to Certn</Trans>
        </Text>
        <Text style="form/body-primary" color="text-weak" align="center">
          <Trans>
            Close this browser tab or{" "}
            <Link onPress={returnToCertn} testID="konfir-callback-close-link">
              click here
            </Link>{" "}
            to return to your background check with Certn.
          </Trans>
        </Text>
      </Stack>
    </Stack>
  );
}
